export var FontTypes = function (FontTypes) {
  FontTypes["noto"] = "noto";
  FontTypes["openSans"] = "openSans";
  FontTypes["openDyslexic"] = "openDyslexic";
  FontTypes["lexend"] = "lexend";
  FontTypes["frankRuhl"] = "frankRuhl";
  FontTypes["materialIconsOutlined"] = "materialIconsOutlined";
  FontTypes["nativeEmoji"] = "nativeEmoji";
  return FontTypes;
}({});